export default __webpack_public_path__ + "static/media/s6.c2700901.png";